import { render, staticRenderFns } from "./ElementHousesComp.vue?vue&type=template&id=72950ad2&"
import script from "./ElementHousesComp.vue?vue&type=script&lang=js&"
export * from "./ElementHousesComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports